import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function BookingCancelledPage() {
  return (
    <div className="min-h-[70vh] bg-[#f7f8fa] py-20" data-testid="booking-cancelled-page">
      <div className="container-titan max-w-xl">
        <div className="bg-white border border-gray-200 p-10 text-center">
          <XCircle className="mx-auto text-[#e63946]" size={56} />
          <h1 className="font-display text-3xl font-bold text-[#0d2040] mt-6">Payment cancelled</h1>
          <p className="text-gray-600 mt-3">Your booking was not confirmed. You can pick another car or try again.</p>
          <div className="mt-8 flex gap-3 justify-center">
            <Link to="/fleet" className="btn-primary">Browse fleet <ArrowRight size={14} /></Link>
            <Link to="/contact" className="btn-outline-navy">Contact us</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
